import React, { useState, useEffect } from 'react'
import { Button, Grid2, TextField, MenuItem, Typography, CircularProgress, Box } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { FilterList } from '@mui/icons-material'
import { useHomeStore } from 'context/HomeStore'
import { useAuthStore } from 'context/AuthStore'
import MaskedTextInput from 'asterX-UI/Inputs/MackedTextInput'
import { AutoCompleteField, SelectPlaceholder } from 'asterX-UI/Inputs'
import { DatePicker } from '@mui/x-date-pickers'
import { parse, format } from 'date-fns'

import BottomDialog from 'asterX-UI/BottomDialog/BottomDialog'
import { GRAY_COLORS } from 'asterX-UI'
import { ACCOUNTANT } from 'lib/constants/roles'
import { CreditFlow } from 'lib/api/services/creditFlow.service'
import ExportClientBankModal from 'components/RoleModals/ExportClientBankModal/ExportClientBankModal'
import CreateAllDdsModal from 'components/RoleModals/CreateAllDdsModal/CreateAllDdsModal'

export const Filter = () => {
  const { authStore } = useAuthStore()
  const {
    homeStore: { filter, banks, creditProducts, tab },
    homeStoreFunc: { handleSearch, handleClearFilter, handleFilterChange }
  } = useHomeStore()
  const [mobileFilter, setMobileFilter] = useState(false)
  const [exportClientBank, setExportClientBank] = useState(false)
  const [createDDS, setCreateDDS] = useState(false)

  const [cities, setCities] = useState([])
  const [groups, setGroups] = useState([])
  const [isLoadingCreditProducts, setIsLoadingCreditProducts] = useState(false)

  useEffect(() => {
    if (tab === 'dealers') {
      CreditFlow.getCitiesDropdown()
        .then(res => setCities(res.data || []))
        .catch(() => setCities([]))
      CreditFlow.getDealerGroupsFilter({ offset: 0, limit: 100 })
        .then(res => setGroups(res.data?.list || []))
        .catch(() => setGroups([]))
    }
  }, [tab])

  useEffect(() => {
    creditProducts?.length === 0 ? setIsLoadingCreditProducts(true) : setIsLoadingCreditProducts(false)
  }, [creditProducts])

  const handleDateChange = field => newValue => {
    const formatted = newValue ? format(newValue, 'dd.MM.yyyy') : null
    handleFilterChange({ target: { name: field, value: formatted } })
  }

  const isDictTab = ['groups', 'dealers', 'locations'].includes(tab)

  if (authStore.isMobile && !isDictTab) {
    return (
      <>
        <Button fullWidth variant="outlined" onClick={() => setMobileFilter(true)}>
          <FilterList /> Фильтр
        </Button>
        <BottomDialog title="Фильтр" open={mobileFilter} onClose={() => setMobileFilter(false)}></BottomDialog>
      </>
    )
  }

  return (
    <>
      <Grid2
        container
        spacing={2}
        sx={{
          width: '100%',
          margin: 0,
          padding: 5,
          borderRadius: 2,
          border: `1px solid ${GRAY_COLORS[200]}`,
          marginBottom: 2
        }}
      >
        {isDictTab ? (
          <>
            {tab === 'groups' && (
              <>
                <Grid2 xs={6}>
                  <TextField
                    fullWidth
                    placeholder="Название группы"
                    name="name"
                    value={filter.name || ''}
                    onChange={handleFilterChange}
                  />
                </Grid2>
                <Grid2 xs={6}>
                  <TextField
                    fullWidth
                    placeholder="Код группы"
                    name="code"
                    value={filter.code || ''}
                    onChange={handleFilterChange}
                  />
                </Grid2>
              </>
            )}

            {tab === 'dealers' && (
              <>
                <Grid2 sx={{ flex: '1.5 1 0', minWidth: 0 }}>
                  <TextField
                    fullWidth
                    placeholder="Название дилера"
                    name="name"
                    value={filter.name || ''}
                    onChange={handleFilterChange}
                  />
                </Grid2>
                <Grid2 sx={{ flex: '1.5 1 0', minWidth: 0 }}>
                  <TextField
                    fullWidth
                    placeholder="Код дилера"
                    name="code"
                    value={filter.code || ''}
                    onChange={handleFilterChange}
                  />
                </Grid2>
                <Grid2 sx={{ flex: '0.5 1 0', minWidth: 0 }}>
                  <SelectPlaceholder
                    IconComponent={props => <ExpandMoreIcon {...props} />}
                    placeholder="Город"
                    name="cityId"
                    value={filter.cityId || ''}
                    onChange={handleFilterChange}
                    fullWidth
                  >
                    <MenuItem value="">Не выбрано</MenuItem>
                    {cities.map(c => (
                      <MenuItem key={c.id} value={c.id}>
                        {c.name}
                      </MenuItem>
                    ))}
                  </SelectPlaceholder>
                </Grid2>
                <Grid2 sx={{ flex: '1 1 0', minWidth: 0 }}>
                  <SelectPlaceholder
                    IconComponent={props => <ExpandMoreIcon {...props} />}
                    placeholder="Группа дилеров"
                    name="dealerGroupCode"
                    value={filter.dealerGroupCode || ''}
                    onChange={handleFilterChange}
                    fullWidth
                  >
                    <MenuItem value="">Не выбрано</MenuItem>
                    {groups.map(g => (
                      <MenuItem key={g.id} value={g.code}>
                        {g.name}
                      </MenuItem>
                    ))}
                  </SelectPlaceholder>
                </Grid2>
              </>
            )}

            {tab === 'locations' && (
              <Grid2 xs={6}>
                <TextField
                  fullWidth
                  placeholder="Название города"
                  name="name"
                  value={filter.name || ''}
                  onChange={handleFilterChange}
                />
              </Grid2>
            )}
            <Grid2
              xs={12}
              container
              justifyContent="flex-end"
              spacing={1}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Grid2>
                <Button variant="outlined" onClick={handleClearFilter}>
                  Сбросить
                </Button>
              </Grid2>
              <Grid2>
                <Button variant="contained" onClick={handleSearch}>
                  Найти
                </Button>
              </Grid2>
            </Grid2>
          </>
        ) : (
          <>
            <Grid2 size={{ xs: 12 }} display="flex" flexDirection="row" gap={2}>
              <Grid2 size="grow">
                <TextField
                  placeholder="ФИО клиента"
                  name="fullName"
                  value={filter.fullName || ''}
                  onChange={handleFilterChange}
                  fullWidth
                />
              </Grid2>

              <Grid2 size="grow">
                <MaskedTextInput
                  placeholder="ИИН"
                  name="iin"
                  value={filter.iin || ''}
                  onChange={handleFilterChange}
                  mask="999999999999"
                  fullWidth
                />
              </Grid2>

              {![ACCOUNTANT].includes(authStore.isUserRole) && (
                <Grid2 size="grow">
                  <SelectPlaceholder
                    IconComponent={props => <ExpandMoreIcon {...props} />}
                    placeholder="Статус"
                    name="statusCode"
                    value={filter.statusCode || ''}
                    onChange={handleFilterChange}
                    fullWidth
                  >
                    <MenuItem value="">Не выбрано</MenuItem>

                    <MenuItem value="userUnderwriterDecision">Рассмотрение заявки</MenuItem>
                      <MenuItem value="userClientAgreement">Принятие условий</MenuItem>
                      <MenuItem value="userUploadCollateralDocs">Документы дилера</MenuItem>
                      <MenuItem value="userCheckCollateral">Проверка документов залога</MenuItem>
                      <MenuItem value="userUploadClientBankDocs">Подписание клиентом</MenuItem>
                      <MenuItem value="userUploadMfoBankDocs">Подписание МФО</MenuItem>
                      <MenuItem value="userCheckBankDocs">Финальная проверка</MenuItem>
                    <MenuItem value="serviceComplete">Выдан</MenuItem>
                      <MenuItem value="serviceRefuse">Отказано</MenuItem>
                      <MenuItem value="userCreateLoanApplication">Создание заявки</MenuItem>
                    <MenuItem value="userAlternative">Выбор альтернативы</MenuItem>
                    <MenuItem value="userSetDDS">Финансирование</MenuItem>
                    <MenuItem value="userRevert">Редактирование заявки</MenuItem>
                    <MenuItem value="userClientConsidering">Клиент думает</MenuItem>
                    <MenuItem value="userHeadUnderwriterDecision">Проверка руководителя андеров</MenuItem>
                    {['applications', 'main'].includes(tab) && (
                      <MenuItem value="userClientRefused">Отказ клиента</MenuItem>
                    )}
                  </SelectPlaceholder>
                </Grid2>
              )}

              <Grid2 size="grow">
                <TextField
                  placeholder={
                    authStore.isUserRole === ACCOUNTANT || tab === 'contracts' ? 'Номер контракта' : 'Номер заявки'
                  }
                  name={authStore.isUserRole === ACCOUNTANT || tab === 'contracts' ? 'contractId' : 'loanApplicationId'}
                  value={
                    authStore.isUserRole === ACCOUNTANT || tab === 'contracts'
                      ? filter.contractId || ''
                      : filter.loanApplicationId || ''
                  }
                  onChange={handleFilterChange}
                  fullWidth
                />
              </Grid2>

              <Grid2 size="grow">
                <AutoCompleteField
                  name="creditProductCode"
                  value={filter.creditProductCode || ''}
                  valueKey="name"
                  placeholder="Не выбрано"
                  options={creditProducts}
                  getOptionLabel={option => option?.name || ''}
                  onChange={handleFilterChange}
                  fullWidth
                  filterOptions={(options, { inputValue }) =>
                    options.filter(option => option.name.toLowerCase().includes(inputValue.toLowerCase()))
                  }
                  loading={isLoadingCreditProducts}
                  loadingText={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pl: 1 }}>
                      <CircularProgress size={18} /> <span>Загрузка...</span>
                    </Box>
                  }
                />
              </Grid2>

              {/* {authStore.isUserRole === ACCOUNTANT && (
                <Grid2 size="grow">
                  <SelectPlaceholder
                    IconComponent={props => <ExpandMoreIcon {...props} />}
                    placeholder="Банк"
                    name="bankBin"
                    value={filter.bankBin || ''}
                    onChange={handleFilterChange}
                    fullWidth
                  >
                    <MenuItem value="">Не выбрано</MenuItem>
                    {banks?.map(item => (
                      <MenuItem value={item?.bin} key={item?.id}>
                        {item?.name}
                      </MenuItem>
                    ))}
                  </SelectPlaceholder>
                </Grid2>
              )} */}
            </Grid2>

            <Grid2 container spacing={1} sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }} gap="8px">
              {/* {authStore.isUserRole === ACCOUNTANT && (
                <Grid2 size="auto" display="flex" gap="8px" marginRight="auto">
                  <Button
                    sx={{
                      fontSize: 14,
                      fontWeight: 600,
                      minWidth: 200
                    }}
                    fullWidth
                    variant="outlined"
                    color="info"
                    onClick={() => setCreateDDS(true)}
                  >
                    Создать ДДС
                  </Button>

                  <Button
                    sx={{
                      fontSize: 14,
                      fontWeight: 600,
                      minWidth: 200
                    }}
                    fullWidth
                    variant="outlined"
                    color="success"
                    onClick={() => setExportClientBank(true)}
                  >
                    Выгрузить банк клиента
                  </Button>
                </Grid2>
              )} */}

              {![ACCOUNTANT].includes(authStore.isUserRole) && (
                <Grid2 container size="grow" gap="8px" justifyContent="flex-start">
                  <Grid2 size={{ xs: 3 }} sx={{ minWidth: 180 }}>
                    <Typography variant="small">Дата создания от</Typography>

                    <DatePicker
                      value={filter.createdDateFrom ? parse(filter.createdDateFrom, 'dd.MM.yyyy', new Date()) : null}
                      onChange={handleDateChange('createdDateFrom')}
                      fullWidth
                      format={'dd.MM.yyyy'}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </Grid2>

                  <Grid2 size={{ xs: 3 }} sx={{ minWidth: 180 }}>
                    <Typography variant="small">Дата создания до</Typography>

                    <DatePicker
                      value={filter.createdDateTo ? parse(filter.createdDateTo, 'dd.MM.yyyy', new Date()) : null}
                      onChange={handleDateChange('createdDateTo')}
                      fullWidth
                      format={'dd.MM.yyyy'}
                      KeyboardButtonProps={{
                        'aria-label': 'change date'
                      }}
                    />
                  </Grid2>
                </Grid2>
              )}

              <Grid2 size={{ xs: 2 }}>
                <Button
                  sx={{ borderColor: GRAY_COLORS[300], color: GRAY_COLORS[800], fontSize: 14, fontWeight: 600 }}
                  fullWidth
                  variant="outlined"
                  onClick={handleClearFilter}
                >
                  Сбросить
                </Button>
              </Grid2>

              <Grid2 size={{ xs: 2 }}>
                <Button
                  sx={{ fontSize: 14, fontWeight: 600 }}
                  fullWidth
                  variant="outlined"
                  color="primary"
                  onClick={handleSearch}
                >
                  Найти
                </Button>
              </Grid2>
            </Grid2>
          </>
        )}

        <BottomDialog title="Фильтр" open={mobileFilter} onClose={() => setMobileFilter(false)}>
          {/* Мобильная версия фильтра */}
        </BottomDialog>
      </Grid2>
      <ExportClientBankModal open={exportClientBank} onClose={() => setExportClientBank(false)} />
      <CreateAllDdsModal open={createDDS} onClose={() => setCreateDDS(false)} />
    </>
  )
}
